/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LiquidityAddOptions,
  LiquidityAddStatus201,
  LiquidityAddStatus400,
  LiquidityAddStatus401,
  LiquidityAddStatus404,
  LiquidityAddStatus409,
  LiquidityAddStatus500,
} from '../types/LiquidityAdd'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { liquidityAdd } from '../clients/liquidityAdd'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const liquidityAddMutationKey = () => [{ url: '/v1/liquidity/pool/:pool_id/add' }] as const

export function liquidityAddMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = liquidityAddMutationKey()
  return mutationOptions<
    LiquidityAddStatus201,
    ResponseErrorConfig<
      | LiquidityAddStatus400
      | LiquidityAddStatus401
      | LiquidityAddStatus404
      | LiquidityAddStatus409
      | LiquidityAddStatus500
    >,
    LiquidityAddOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return liquidityAdd({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Add liquidity to a pool
 * {@link /v1/liquidity/pool/:pool_id/add}
 */
export function useLiquidityAdd<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LiquidityAddStatus201,
      ResponseErrorConfig<
        | LiquidityAddStatus400
        | LiquidityAddStatus401
        | LiquidityAddStatus404
        | LiquidityAddStatus409
        | LiquidityAddStatus500
      >,
      LiquidityAddOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? liquidityAddMutationKey()

  const baseOptions = liquidityAddMutationOptions(config) as UseMutationOptions<
    LiquidityAddStatus201,
    ResponseErrorConfig<
      | LiquidityAddStatus400
      | LiquidityAddStatus401
      | LiquidityAddStatus404
      | LiquidityAddStatus409
      | LiquidityAddStatus500
    >,
    LiquidityAddOptions,
    TContext
  >

  return useMutation<
    LiquidityAddStatus201,
    ResponseErrorConfig<
      | LiquidityAddStatus400
      | LiquidityAddStatus401
      | LiquidityAddStatus404
      | LiquidityAddStatus409
      | LiquidityAddStatus500
    >,
    LiquidityAddOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LiquidityAddStatus201,
    ResponseErrorConfig<
      | LiquidityAddStatus400
      | LiquidityAddStatus401
      | LiquidityAddStatus404
      | LiquidityAddStatus409
      | LiquidityAddStatus500
    >,
    LiquidityAddOptions,
    TContext
  >
}
